import { WorkshopOrDevelopmentProgrammCreatedEvent } from "./WorkshopOrDevelopmentProgrammCreatedEvent";

export const DevelopmentProgramCreatedEvent = ({ event }) => {
  return <WorkshopOrDevelopmentProgrammCreatedEvent event={event} />;
};
